import React from "react";
import { Timezone } from "@linkfluence/models/timezone";
import DateComponent from "@radarly/components/cards/card/subtitle/date";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import { getDateFromClause } from "@radarly/models/clause/getter";
import { AIFragment, SearchFragment } from "@radarly/models/search";

export default function SharedCardsSubtitleDate({
  fragment,
  timezone,
  nowDate,
}: {
  fragment: SearchFragment | AIFragment;
  timezone: Timezone;
  nowDate?: Date;
}) {
  const { from, to } = getDateFromClause(fragment.request.query);
  const locale = useCurrentUserLocale();
  return (
    <DateComponent
      from={from}
      to={to}
      locale={locale}
      timezone={timezone}
      nowDate={nowDate}
    />
  );
}
